import { gql } from "@apollo/client";

import { LANGUAGE_REPRESENTATIVE_EDUCATOR_DIPLOMA_FIELDS } from "../queries/languageRepresentativeEducatorDiplomas";

export const CREATE_LANGUAGE_REPRESENTATIVE_EDUCATOR_DIPLOMA = gql`
  mutation CreateLanguageRepresentativeEducatorDiploma(
    $input: UpdateLanguageRepresentativeEducatorDiplomaInput!
  ) {
    createCertLanguageRepresentativeEducatorDiploma(input: $input) {
      ...LanguageRepresentativeEducatorDiplomaFields
    }
  }
  ${LANGUAGE_REPRESENTATIVE_EDUCATOR_DIPLOMA_FIELDS}
`;

export const UPDATE_LANGUAGE_REPRESENTATIVE_EDUCATOR_DIPLOMA = gql`
  mutation UpdateLanguageRepresentativeEducatorDiploma(
    $id: ID!
    $input: UpdateLanguageRepresentativeEducatorDiplomaInput!
  ) {
    updateCertLanguageRepresentativeEducatorDiploma(id: $id, input: $input) {
      ...LanguageRepresentativeEducatorDiplomaFields
    }
  }
  ${LANGUAGE_REPRESENTATIVE_EDUCATOR_DIPLOMA_FIELDS}
`;

export const DELETE_LANGUAGE_REPRESENTATIVE_EDUCATOR_DIPLOMA = gql`
  mutation DeleteLanguageRepresentativeEducatorDiploma($id: ID!) {
    deleteCertLanguageRepresentativeEducatorDiploma(id: $id) {
      id
    }
  }
`;
